import { ViewTodaysPriceChangeService } from './ViewTodaysPriceChangeService';
import { ViewGridColumnGroupDto } from '../../view-grid/interfaces/ViewGridColumnGroupDto';

export class ViewSocketService {
  static isAvailable(columnsGroups: ViewGridColumnGroupDto[]): boolean {
    return ViewTodaysPriceChangeService.hasTodaysPriceChange(columnsGroups);
  }
}
